import dayjs from 'dayjs'
import i18next from 'i18next'
import './time.locale'

export const initDayJs = (lang: string) => {
  switchDayJsLocale(lang)
}

export const switchDayJsLocale = (lang: string) => {
  require(`dayjs/locale/${lang}.js`)
  dayjs.locale(lang)
}

export const fromNowToFullDate = (date: dayjs.ConfigType) => {
  const within24Hours = dayjs().diff(dayjs(date), 'hours') < 24
  const yesterday = dayjs(date).isYesterday()
  const withinAWeek = dayjs().diff(dayjs(date), 'week') < 1
  const withinTheYear = dayjs(date).year() === dayjs().year()

  if (within24Hours) {
    return dayjs(date).fromNow()
  } else if (yesterday) {
    return i18next.t('common.yesterday')
  } else if (withinAWeek) {
    return dayjs(date).format('dddd')
  } else if (withinTheYear) {
    return dayjs(date).format('MM/DD')
  }

  return dayjs(date).format('YYYY/MM/DD')
}

export const Now = {
  ms: () => Date.now(),
  s: () => Date.now() / 1000,
}
